var $ = require("jquery");
require("slick-carousel/slick/slick.scss");
require("slick-carousel");

$(document).ready(() => {
  $("#location-carousel").slick({
    centerMode: true,
    slidesToShow: 5,
    infinite: true,
    dots: true,
    prevArrow: false,
    lazyLoad: "ondemand",
    nextArrow: false,
    focusOnSelect: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          centerMode: true,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1024,
        settings: {
          centerMode: true,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1
        }
      }
    ]
  });
});
